import Plotly from 'plotly.js-dist-min';
import createPlotlyComponent from 'react-plotly.js/factory';

import { createSafePlotlyComponent } from './utils';

const PlotlyComponent = createPlotlyComponent(Plotly);

export const SafePlotlyComponent = createSafePlotlyComponent(PlotlyComponent);
